import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import VacancyService from "@/services/vacancy.service";
import { VacancyApplicantDto, VacancyApplicantNoteFormDto, VacancyDetailsDto, VacancyDto, VacancyFormDataDto, VacancyFormDto } from "@/types/vacancy.type";

@Module({ namespaced: true })
class VacancyModule extends VuexModule {
  vacancies: VacancyDto[] = [];
  vacancyForm = new VacancyFormDto();
  vacancyFormData: VacancyFormDataDto | null = null;
  vacancyDetails: VacancyDetailsDto | null = null;
  vacancyApplicant: VacancyApplicantDto | null = null;
  vacancyNoteForm = new VacancyApplicantNoteFormDto();

  @Action({ rawError: true })
  resetForm(): void {
    this.context.commit("updateField", {
      path: "vacancyForm",
      value: new VacancyFormDto()
    });
  }

  @Action({ rawError: true })
  resetDetails(): void {
    this.context.commit("updateField", {
      path: "vacancyDetails",
      value: null
    });
  }

  @Action({ rawError: true })
  async get(practiceId: number): Promise<void> {
    const vacancies = await VacancyService.getByPracticeAsync(practiceId);
    
    this.context.commit("updateField", {
      path: "vacancies",
      value: vacancies
    });
  }
  
  @Action({ rawError: true })
  async getForm(id: number): Promise<void> {
    const vacancyForm = await VacancyService.getFormAsync(id);

    if (!vacancyForm.schedulerIds) {
      vacancyForm.schedulerIds = [];
    }

    this.context.commit("updateField", {
      path: "vacancyForm",
      value: vacancyForm
    });
  }

  @Action({ rawError: true })
  async getFormData(practiceId: number): Promise<void> {
    const vacancyFormData = await VacancyService.getFormDataAsync(practiceId);

    this.context.commit("updateField", {
      path: "vacancyFormData",
      value: vacancyFormData
    });
  }

  @Action({ rawError: true })
  async getDetails(data: { id: number, practiceId: number }): Promise<void> {
    const vacancyDetails = await VacancyService.getDetailsAsync(data.id, data.practiceId);

    this.context.commit("updateField", {
      path: "vacancyDetails",
      value: vacancyDetails
    });
  }

  @Action({ rawError: true })
  async delete(id: number): Promise<void> {
    await VacancyService.deleteAsync(id);
  }

  @Action({ rawError: true })
  async updateInterest(data: { userId: number, vacancyId: number, isInterested: boolean | null }): Promise<void> {
    await VacancyService.updateInterestAsync(data.vacancyId, data.userId, data.isInterested);
  }

  @Action({ rawError: true })
  async updateHire(data: { userId: number, vacancyId: number }): Promise<void> {
    await VacancyService.updateHireAsync(data.vacancyId, data.userId);
  }

  @Action({ rawError: true })
  async updateFill(vacancyId: number): Promise<void> {
    await VacancyService.updateFillAsync(vacancyId);
  }

  @Action({ rawError: true })
  async repost(vacancyId: number): Promise<void> {
    const form = await VacancyService.getFormAsync(vacancyId);
    
    form.id = null;

    if (!form.schedulerIds?.length) {
      form.schedulerIds = null;
    }

    await VacancyService.saveAsync(form);
  }

  @Action({ rawError: true })
  async save(form: VacancyFormDto): Promise<void> {
    if (!form.schedulerIds?.length) {
      form.schedulerIds = null;
    }

    await VacancyService.saveAsync(form);
  }

  @Action({ rawError: true })
  async saveNote(form: VacancyApplicantNoteFormDto): Promise<void> {
    await VacancyService.saveNoteAsync(form);
  }

  @Action({ rawError: true })
  async deleteNote(id: number): Promise<void> {
    await VacancyService.deleteNoteAsync(id);
  }
}

VacancyModule.getters = { getField };
VacancyModule.mutations = { updateField };

export default VacancyModule;